import { MemberRole } from "features/team/model/types/members"

export enum Filter {
  All = 'all',
  Today = 'today',
  Last30Days = 'last30days',
  Last7Days = 'last7days',
  Last6Months = 'last6months',
  ThisYear = 'thisYear',
  LastYear = 'lastYear',
}

export const hasAccess = (currentUserRole: MemberRole, rolesWithAccess: MemberRole[]) => {
  return rolesWithAccess.includes(currentUserRole)
}

export function getDateRange(filter: string): [Date | null, Date | null] {
  const now = new Date()
  switch (filter) {
  case Filter.Today:
    return [new Date(now.getFullYear(), now.getMonth(), now.getDate()), now]
  case Filter.Last7Days:
    return [new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), now]
  case Filter.Last30Days:
    return [new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000), now]
  case Filter.Last6Months:
    return [new Date(now.getTime() - 6 * 30 * 24 * 60 * 60 * 1000), now]
  case Filter.ThisYear:
    return [new Date(now.getFullYear(), 0, 1), now]
  case Filter.LastYear:
    return [
      new Date(now.getFullYear() - 1, 0, 1),
      new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999)
    ]
  default:
    return [null, null]
  }
}

